import Rebase from 're-base'
import firebase from 'firebase/app'
import database from 'firebase/database'
import 'firebase/auth'

const app = firebase.initializeApp({
    apiKey: "AIzaSyAS4QJ5GagdL2bWvr5tRzmr6Kvm1vTW0Ks",
    authDomain: "noteherder-fed46.firebaseapp.com",
    databaseURL: "https://noteherder-fed46.firebaseio.com",
    projectId: "noteherder-fed46",
    storageBucket: "noteherder-fed46.appspot.com",
    messagingSenderId: "1044925083691"
  })

const db = database(app)

export const auth = app.auth();
export const githubProvider = new firebase.auth.GithubAuthProvider()
export const googleProvider = new firebase.auth.GoogleAuthProvider()
export const facebookProvider = new firebase.auth.FacebookAuthProvider()

export default Rebase.createClass(db)



// WEBPACK FOOTER //
// ./src/base.js